import { useEffect, useRef } from "react";
import { openGamePortal, type GamePortalLaunchOptions } from "../forum-auth";

export interface GamePortalRedirectProps extends GamePortalLaunchOptions {
  onBeforeOpen?: () => void;
}

/**
 * Compatibility bridge for legacy in-game portal routes.
 * Commit the local return target before replacing the WebView document so an APK
 * can always land back in the game instead of reopening the portal in a loop.
 */
export function GamePortalRedirect({ target, selectedModelId, onBeforeOpen }: GamePortalRedirectProps) {
  const startedRef = useRef(false);
  const beforeOpenRef = useRef(onBeforeOpen);
  const launchRef = useRef<GamePortalLaunchOptions>({ target, selectedModelId });
  beforeOpenRef.current = onBeforeOpen;
  launchRef.current = { target, selectedModelId };

  useEffect(() => {
    if (startedRef.current) return;
    startedRef.current = true;
    beforeOpenRef.current?.();

    // Intentionally keep this timer after the redirect component unmounts: the
    // local navigation must render first, then the top-level WebView may leave.
    window.setTimeout(() => openGamePortal(launchRef.current), 0);
  }, []);

  return null;
}
